// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"299":"how-to-work","670":"features","928":"privacy-policy","934":"contact-us","957":"privacy"}[chunkId] + "." + {"299":"cbd397aa","670":"cc7b8f26","928":"b51c1c69","934":"061fd29e","957":"93ba89ec"}[chunkId] + ".css";
};